import { useCallback, useState } from "react";
import { ArrowLeft, Save, Upload } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { SERVER_URL } from "../../utils/config";
// import copy from "copy-to-clipboard";
import { message } from "../../utils/toast";
import { Label } from "../../components/ui/Label";
import { Input } from "../../components/ui/Input";
import { Button } from "../../components/ui/Button";
import { Spinner } from "../../components/ui/Spinner";
import axios from "axios";

const AddLeadFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    photo: null,
    photoPreview: "",
    campaign_id: ""
  });
  const [loading, setLoading] = useState(false);

  // const landingPageUrl = `${BASE_URL}/campaign/${id}`;

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        photo: file,
        photoPreview: URL.createObjectURL(file)
      }));
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif"]
    },
    maxFiles: 1
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const createLead = () => {
    const form = new FormData();
    form.append("lead_name", formData.name);
    form.append("photo", formData.photo);
    form.append("campaign_id", id);

    setLoading(true);
    axios
      .post(`${SERVER_URL}/api/lead`, form)
      .then(({ data }) => {
        switch (data.message) {
          case "lead_created":
            message({
              type: "success",
              content: "Lead created successfully"
            });
            break;

          default:
            break;
        }
        setLoading(false);
        navigate(`/campaigns-list/${id}/leads`);
      })
      .catch((error) => {
        setLoading(false);
        message({ type: "error", content: error.message });
      });
  };

  // const copyLandingPageUrl = () => {
  //   copy(landingPageUrl);
  //   message({ type: "success", content: "Link copied" });
  // };

  return (
    <div className="p-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center justify-between max-md:block">
          <div className="flex items-center gap-4 max-md:block">
            <Link
              to={`/campaigns-list/${id}/leads`}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft size={20} />
              <span>Back to Leads</span>
            </Link>
            <h1 className="text-2xl font-bold text-gray-900">Add Lead</h1>
          </div>
          <Button
            className={
              "text-white bg-indigo-600 h-10 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors max-md:mt-4 max-md:flex max-md:justify-center max-md:w-full"
            }
            onClick={createLead}
          >
            {loading ? (
              <Spinner />
            ) : (
              <>
                <Save size={20} />
                &nbsp;Save Changes
              </>
            )}
          </Button>
        </div>

        <div className="space-y-6">
          <div>
            <Label htmlFor={"name"} className={"block mb-1"}>
              Lead Name
            </Label>
            <Input
              className="mt-1 block px-3"
              placeholder="Enter lead name"
              type="text"
              value={formData.name}
              id="name"
              name="name"
              onChange={handleChange}
            />
          </div>

          <div>
            <Label htmlFor={"photo"} className={"block mb-1"}>
              Profile Photo
            </Label>
            <div
              {...getRootProps()}
              className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors
                ${
                  isDragActive
                    ? "border-indigo-500 bg-indigo-50"
                    : "border-gray-300 hover:border-indigo-500"
                }`}
            >
              <input id="photo" {...getInputProps()} />
              <Upload className="mx-auto h-12 w-12 text-gray-400" />
              <p className="mt-2 text-sm text-gray-600">
                Drag & drop a photo here, or click to select one
              </p>
              <p className="mt-1 text-xs text-gray-500">
                PNG, JPG, GIF up to 10MB
              </p>
            </div>
          </div>

          {formData.photoPreview && (
            <div className="mt-4">
              <h4 className="text-sm font-medium text-gray-700 mb-2">
                Preview
              </h4>
              <img
                src={formData.photoPreview}
                alt="Profile preview"
                className="w-20 h-20 rounded-full object-cover border-2 border-gray-200"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddLeadFormPage;
